import { render, staticRenderFns } from "./collectCancelDialog.vue?vue&type=template&id=314fa6bd&scoped=true"
import script from "./collectCancelDialog.vue?vue&type=script&lang=js"
export * from "./collectCancelDialog.vue?vue&type=script&lang=js"
import style0 from "./collectCancelDialog.vue?vue&type=style&index=0&id=314fa6bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314fa6bd",
  null
  
)

export default component.exports